import { SelectIF } from '@/types/common';

export type EventT =
    | 'BusinessTrip'
    | 'Vacation'
    | 'BusinessTravel'
    | 'Excursion'
    | 'ActiveTrip'
    | 'FamilyTrip'
    | 'RomanticGetaway'
    | 'EventTravel'
    | 'EducationalTrip'
    | 'Walk'
    | 'Weekend';

export const EVENTS_PROPERTIES: SelectIF<EventT>[] = [
    {
        value: 'BusinessTrip',
        label: 'Деловая поездка',
    },
    {
        value: 'Vacation',
        label: 'Отпуск',
    },
    {
        value: 'BusinessTravel',
        label: 'Командировка',
    },
    {
        value: 'Excursion',
        label: 'Экскурсия',
    },
    {
        value: 'ActiveTrip',
        label: 'Приключение',
    },
    {
        value: 'FamilyTrip',
        label: 'Семейное путешествие',
    },
    {
        value: 'RomanticGetaway',
        label: 'Романтическая поездка',
    },
    {
        value: 'EventTravel',
        label: 'Мероприятия',
    },
    {
        value: 'EducationalTrip',
        label: 'Образовательная поездка',
    },
    {
        value: 'Walk',
        label: 'Прогулка',
    },
    {
        value: 'Weekend',
        label: 'Выходные',
    },
];
